import api from '../api/client';
import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  Space,
  message,
  Spin,
  Row,
  Col,
} from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import axios from "axios";
import config from "../config";
// import config from "../../config";

const { Option } = Select;

const StakeholderModal = ({ visible, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const formData = {...values, type: "supplier" };
      console.log("show data", formData)
      const { data } = await api.post(`/stakeholders`, formData);
      message.success("Stakeholder added successfully");
      form.resetFields();
      onSuccess(data); // Pass the new stakeholder back to parent
      onCancel();
    } catch (err) {
      message.error(err.response?.data?.message || "Failed to add stakeholder");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Space>
          <PlusOutlined style={{ color: "#1677ff" }} />
          <span>Add New Stakeholder</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Stakeholder Name"
                rules={[{ required: true, message: "Please enter stakeholder name" }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="company_name"
                label="Business Name"
                rules={[{ required: true, message: "Please enter company name" }]}
              >
                <Input placeholder="Enter company name" />
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: "Please select type" }]}
              >
                <Select placeholder="Select type">
                  {typeOptions.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col> */}
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="email" label="Email">
                <Input type="email" placeholder="Enter email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="phone" label="Phone Number">
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="address" label="Address">
            <Input.TextArea rows={2} placeholder="Enter address" />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Add Stakeholder
              </Button>
              <Button onClick={onCancel}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default StakeholderModal;